import { Field } from "csi/def/Field";
import FormWidget from "csi/form/Widget";
import declare from "dojo/_base/declare";

/**
 * Form controller for DataSheetItemsImportConfiguration
 */
const DataSheetItemsImportConfigurationForm = declare(FormWidget, {
	ALLOW_SPECIALS: "AllowSpecials",
	SPECIAL_ITEM_SUBTYPE: "SpecialItemSubtype",

	// Boolean: write only visible fields
	bWriteVisible: true,

	/**
	 * Display "SpecialItemSubtype" fields IFF AllowSpecials==true (Jira: C8FB-18)
	 * @override
	 */
	_updateFieldVisibility(field: Field) {
		this.inherited(arguments);

		const allowSpecialsField = this.getField(this.ALLOW_SPECIALS);
		const specialItemSubtypeField = this.getField(this.SPECIAL_ITEM_SUBTYPE);
		if (specialItemSubtypeField) {
			this.setFieldHidden(this.SPECIAL_ITEM_SUBTYPE, !allowSpecialsField?.getValue());
		}

		return true;
	},
});

export = DataSheetItemsImportConfigurationForm;
